import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-settings-product-overview',
  templateUrl: './settings-product-overview.component.html',
  styleUrls: ['./settings-product-overview.component.scss']
})
export class SettingsProductOverviewComponent implements OnInit {

  constructor(private router: Router) { }
  
    ngOnInit() {
      this.router.navigate(['backoffice/settings/product_overview/product_list']);
    }
  
    goto(route, event){
      if(event){
        let target = event.target || event.srcElement || event.currentTarget;
        let a = document.querySelectorAll('section[id="submenu"] a');
        for(let i=0; i<a.length; i++){
          a[i].className = 'nav-link';
        } 
        (<HTMLInputElement>target).className= "nav-link active";
      }
      this.router.navigate(['/backoffice/settings/product_overview',route]);
    }
}
